import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CompanyProfile() {
  const { t } = useTranslation();
  return (
    <section id="company" className="bg-white py-16 sm:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="mb-12 sm:mb-16">
          <p className="text-[#255485] text-sm font-medium tracking-wider mb-2">{t('company.eyebrow')}</p>
          <h2 className="text-2xl sm:text-3xl font-serif text-gray-900">{t('company.title')}</h2>
        </div>
        <div className="bg-white rounded-xl border border-gray-200">
          <div className="divide-y divide-gray-200">
            <div className="flex flex-col sm:flex-row py-4 sm:py-6 px-4 sm:px-8">
              <div className="sm:w-1/3 text-gray-600 font-medium mb-2 sm:mb-0">{t('company.name.label')}</div>
              <div className="sm:w-2/3 text-gray-900">{t('company.name.value')}</div>
            </div>
            <div className="flex flex-col sm:flex-row py-4 sm:py-6 px-4 sm:px-8">
              <div className="sm:w-1/3 text-gray-600 font-medium mb-2 sm:mb-0">{t('company.address.label')}</div>
              <div className="sm:w-2/3 text-gray-900">{t('company.address.value')}</div>
            </div>
            <div className="flex flex-col sm:flex-row py-4 sm:py-6 px-4 sm:px-8">
              <div className="sm:w-1/3 text-gray-600 font-medium mb-2 sm:mb-0">{t('company.business.label')}</div>
              <div className="sm:w-2/3 text-gray-900">
                <div className="space-y-2">
                  <p>{t('company.business.value1')}</p>
                  <p>{t('company.business.value2')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 sm:mt-12 text-center">
          <Link to="/company" className="inline-flex items-center gap-2 text-[#255485] hover:text-[#1d4166] transition-colors duration-200 text-sm font-medium cursor-pointer">
            {t('company.link')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
